export default __webpack_public_path__ + "static/media/fb.776fc3f2.webp";